import { calculateBabyAgeInMonths } from "@/lib/utils";

export type ReactionType = "good" | "mild" | "concern";

export interface FoodTry {
  food: string;
  date: string;
  reaction: ReactionType;
  note?: string;
}

export interface BabyProfile {
  id: string;
  name: string;
  birthDate: string;
  ageInMonths: number;
  triedFoods: number;
  totalFoods: number;
  recentTries: FoodTry[];
  is_active?: boolean;
  is_shared?: boolean;
}

// Helper function to convert database Baby to BabyProfile for UI
export function convertBabyToProfile(baby: {
  id: string;
  name: string;
  birth_date: string;
  age_in_months: number;
  is_active?: boolean;
  is_shared?: boolean;
}, triedFoods: number = 0, totalFoods: number = 0, recentTries: FoodTry[] = []): BabyProfile {
  return {
    id: baby.id,
    name: baby.name,
    birthDate: baby.birth_date,
    ageInMonths: baby.birth_date ? calculateBabyAgeInMonths(baby.birth_date) : baby.age_in_months,
    triedFoods,
    totalFoods,
    recentTries,
    is_active: baby.is_active,
    is_shared: baby.is_shared
  };
}